import { ActivatedRoute, Router } from '@angular/router';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { BasePage } from '../../base.page';
import { ContractInterface, GetAppropriatenessClientUseCase, GetSelectedProductsUseCase } from '../../../../core';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { MainRoutes } from '../../../main-routes.enum';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { ParentEvents } from '../../../utils/parent-events.service';
import { TestPage } from '../test.page';

@Component({
    templateUrl: './test-result.page.html',
    styleUrls: ['./test-result.page.scss'],
})
export class TestResultPage extends BasePage implements AfterViewInit, OnInit {
    public hasProductsInappropriateness = false;
    public profileName: string;
    public isSuitability = false;

    constructor(
        parentEvents: ParentEvents,
        protected testPage: TestPage,
        protected dialog: MatDialog,
        protected getAppropriatenessClientUseCase: GetAppropriatenessClientUseCase,
        protected getSelectedProductsUseCase: GetSelectedProductsUseCase,
        protected localStorage: LocalStorage,
        protected route: ActivatedRoute,
        protected router: Router
    ) {
        super(parentEvents);
        testPage.hideBackButton();
    }

    get contract(): ContractInterface {
        return this.testPage.contract;
    }

    ngOnInit() {
        this.getProfileName();

        this.route.queryParams.subscribe((params) => {
            this.isSuitability = params.suitability === '1';
        });
    }

    protected getProfileName() {
        this.getAppropriatenessClientUseCase.bind().subscribe((transaction) => {
            transaction.fold(
                (client) => (this.profileName = client.mifidCompetenceName),
                (err) =>
                    this.dialog.open(ErrorDialog, {
                        data: { text: err.message },
                    })
            );
        });
    }

    onClick() {
        if (this.isSuitability) {
            this.router.navigateByUrl(MainRoutes.TEST_RESULT_SUITABILITY);
        } else {
            if (this.contract.isAdvisoryModelGDC()) {
                this.router.navigateByUrl(MainRoutes.TEST_TRANSFER);
            } else {
                this.router.navigateByUrl(MainRoutes.FULL_DATA);
            }
        }
    }
}
